import React from 'react';
import classNames from 'classnames';
import Button from '../button/Button';
import './verticalNavigation.scss';

interface VerticalNavigationItem {
    label: string;
    icon: string;
    onClick?: () => void;
    error?: boolean;
}

interface VerticalNavigationProps {
    items: VerticalNavigationItem[];
    initialIndex?: number;
    onChange?: (index: number) => void;
}

function VerticalNavigation({items, initialIndex = 0, onChange}: VerticalNavigationProps): JSX.Element {
    return (
        <div className="c-verticalNavigation">
            {items.map((item, index) => (
                <Button
                    className={classNames('c-verticalNavigation__item', {
                        'c-verticalNavigation__item--error': item.error,
                    })}
                    key={item.label}
                    variant={index === initialIndex ? 'solid' : 'ghost'}
                    leading={item.icon}
                    color={item.error ? 'error' : 'primary'}
                    onClick={() => {
                        onChange && onChange(index);
                        item.onClick && item.onClick();
                    }}
                    type="button"
                >
                    {item.label}
                </Button>
            ))}
        </div>
    );
}

export default VerticalNavigation;
